export const LOGIN = "/log-in";
export const DASHBOARD = "/";
export const ENTERPRISE = '/enterprise'
export const CANDIDATE = '/candidate'
export const ENTERPRISE_COMPANY = '/enterprise/company/'



